import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconDocument from 'components/icons/IconDocument';

const styles = theme => ({
  root: {
    minHeight: 330,
  },
  iconDocument: {
    width: 105,
    height: 105,
    color: theme.palette.primary.A400,
  },
});

const PatientsDialogDocumentsListEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={24}
  >
    <Grid item>
      <IconDocument className={classes.iconDocument} />
    </Grid>
    <Grid item>
      <Typography variant="subheading" color="secondary">
        Unfortunately, patient has no documents
      </Typography>
    </Grid>
  </Grid>
);

PatientsDialogDocumentsListEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconDocument: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PatientsDialogDocumentsListEmpty);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsDialog/PatientsDialogDocumentsListEmpty.js